import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import { ContactList } from './components/Contact';
import { FAQ } from './components/FAQ';
import { MobileGuide } from './components/Guide/mobile';
import { Home } from './components/Home';
import { Resources } from './components/Resources';
import { Workflow } from './components/Workflow';
import './index.css';

const nonce = (
  document.querySelector('meta[property="csp-nonce"]') as HTMLMetaElement
)?.content;

const cache = createCache({
  key: 'emotion-cache-key',
  nonce: nonce,
  prepend: true,
});

ReactDOM.render(
  <React.StrictMode>
    <CacheProvider value={cache}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path='/' element={<App />}>
            <Route index element={<Home />} />
            <Route path='/flowchart' element={<Workflow />} />
            <Route path='/resources' element={<Resources />} />
            <Route path='/faq' element={<FAQ />} />
            <Route path='/guide' element={<MobileGuide />} />
            <Route path='/contact' element={<ContactList />} />
            <Route path='*' element={<p>There's nothing here!</p>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CacheProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
